import * as React from 'react';

function useDidImmutableValueChange(value) {
    // remember the initial value
    const initialValue = React.useRef(value);
    // return whether or not the value changed
    return initialValue.current !== value;
}

export { useDidImmutableValueChange };
